import React, { useState } from "react";
import MotionHoc from "../../../utils/MotionHoc";
import { Col, Row, Space, Table, Card, Spin, Select, message, Tooltip, Button, Tag } from "antd";
import Search from "antd/es/input/Search";
import { SearchOutlined, SaveOutlined, BarcodeOutlined } from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import { baseUrlAREA, baseUrlNIKKI, CREATE_CC, HEADERS_BASIC, LOAD_MAIN_CC } from "../../API/apiUrlsNew";
import ThaiDatePicker from "../../../hook/ThaiDatePicker";
import { contractOptions } from "./hook/function";
import PickData from "./modal/PickData";
import CheckCONTNO from "./modal/CheckCONTNO";

function Main() {
    const userCompany = localStorage.getItem("COMPANY_ID");
    const currentMonth = dayjs().month();
    const currentYear = dayjs().year();

    const [loading, setLoading] = useState(false);
    const [arrData, setArrData] = useState([]);
    const [arrayTable, setArrayTable] = useState([]);
    const [datePicker, setDatePicker] = useState();
    const [selectedContract, setSelectedContract] = useState();
    const [isModalPickData, setIsModalPickData] = useState(false);
    const [isModalSearch, setIsModalSearch] = useState(false);
    const [dataSearch, setDataSearch] = useState();
    const USERNAME = localStorage.getItem("USERNAME");
    const COMPANY_ID = localStorage.getItem("COMPANY_ID");

    const handleLoad = () => {
        if (selectedContract?.value && datePicker) {
            loadData();
        } else {
            message.error("กรุณาเลือกสัญญาและวันที่ !! ");
        }
    };

    const loadData = () => {
        setLoading(true);

        const payload = {
            date: datePicker,
            type: selectedContract.value,
            company: userCompany,
        };

        axios.post(baseUrlNIKKI + LOAD_MAIN_CC, payload, { headers: HEADERS_BASIC })
            .then((response) => {
                if (response.status === 200) {
                    // console.log("res data", response.data);
                    setArrayTable(response.data);
                    setArrData(response.data);
                }
            })
            .catch((error) => {
                const status = error?.response?.status;
                const serverMsg = error?.response?.data?.message;
                console.error("API error:", status, serverMsg || error.message);

                setArrayTable([]);
                setArrData([]);
                message.error(
                    serverMsg || `ไม่สามารถดึงข้อมูลได้ (${status ?? " - "})`
                );
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const onSearch = (value) => {
        // console.log("value", value)
        // setLoading(true);
        // let result;

        // if (value) {
        //   result = arrData.filter(
        //     (item) =>
        //       (item.CONTNO && item.CONTNO.includes(value.trim()))
        //     // ||
        //     // (item.NAME && item.NAME.includes(value.trim())) ||
        //     // (item.NAME1 && item.NAME1.includes(value.trim())) ||
        //     // (item.NAME2 && item.NAME2.includes(value.trim())) ||
        //     // (item.REGNO && item.REGNO.includes(value.trim()))
        //   );
        // } else {
        //   result = arrData;
        // setCancelCodeSelect([]);
        setDataSearch(value)
        setIsModalSearch(true)
        // }

        // setTimeout(() => {
        //   setLoading(false);
        // }, 250);
        // setArrayTable(result);
    };

    const insertData = async () => {
        if (!arrData || (Array.isArray(arrData) && arrData.length === 0)) {
            message.error("ไม่มีข้อมูลที่บันทึก");
            return;
        }

        setLoading(true);
        let sendData = {
            contractSchema: selectedContract.value,
            roundDate: datePicker,
            cancelContract: arrayTable,
            user: USERNAME,
            company: COMPANY_ID
        }

        await axios.post(baseUrlAREA + CREATE_CC, sendData, { headers: HEADERS_BASIC })
            .then((res) => {
                if (res.status === 200) {
                    message.success("สร้างข้อมูลใหม่สำเร็จ");
                }
            })
            .catch((error) => {
                // 5. จัดการเมื่อ Error
                const status = error?.response?.status;
                const serverMsg =
                    error?.response?.data?.message ||
                    error?.response?.data?.error ||
                    error.message;

                message.error(
                    `ไม่สามารถส่งข้อมูลได้${status ? ` (${status})` : ""}: ${serverMsg}`
                );

                console.error("insertData error:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleAddBarcode = () => {
        setIsModalPickData(true)
    };

    const columns = [
        {
            title: "ลำดับ",
            key: "key",
            align: "center",
            render: (_, record) => <>{record.key}</>,
        },
        {
            title: "เลขที่สัญญา",
            dataIndex: "CONTNO",
            key: "CONTNO",
            align: "center",
        },
        {
            title: "ชื่อ-นามสกุล",
            dataIndex: "CUSTOMER",
            key: "CUSTOMER",
            align: "center",
            render: (_, record) => (
                <>
                    {record.SNAM} {record.NAME1} {record.NAME2}
                </>
            ),
        },
        {
            title: "ประเภทลูกค้า",
            align: "center",
            render: (_, record) =>
                <>
                    {
                        record?.GARNO === "0" ?
                            <Tag color={"gold"}>ผู้ทำสัญญา</Tag>
                            :
                            <Tag color={"cyan"}>ผู้ค้ำที่ {record.GARNO}</Tag>
                    }
                    {/* <Tag color={"volcano"}>ที่อยู่ {record?.ADDRNO}</Tag> */}
                </>,
        },
        {
            title: "ที่อยู่ลูกค้า",
            align: "center",
            render: (_, record) =>
                <div  >
                    <Tag color={"volcano"}>ที่อยู่ {record?.ADDRNO}</Tag>
                    {record?.ADDR1} {record?.ADDR2} <br />
                    {record?.PROVDES} {record?.AUMPDES} {record?.TUMB} {record?.ZIP}
                </div>,
        },
        {
            title: "ค้างงวด(จริง)",
            dataIndex: "HLDNO",
            key: "HLDNO",
            align: "center",
        },
        {
            title: "ค้างชำระ (วัน)",
            dataIndex: "DPD_DAYS",
            key: "DPD_DAYS",
            align: "center",
        },
    ];


    const onChangeContract = (value) => {
        setSelectedContract(value)
        setArrData([])
        setArrayTable([])
    }

    const onChangeDatePicker = (value) => {
        setDatePicker(value)
        setArrData([])
        setArrayTable([])
    }

    return (
        <>
            <Card>
                <Row>
                    <Col span={12} style={{ textAlign: "start" }}>
                        <Space>
                            <Select
                                key={userCompany}
                                size="large"
                                style={{ minWidth: "auto" }}
                                placeholder="เลือกสัญญา"
                                popupMatchSelectWidth={false}
                                labelInValue
                                value={selectedContract} // ต้องเป็น object { value, label }
                                onChange={(obj) => onChangeContract(obj ?? null)} // obj = { value, label }
                                options={contractOptions}
                                allowClear
                                showSearch
                                optionFilterProp="label"
                            />

                            <ThaiDatePicker
                                value={datePicker}
                                onChange={onChangeDatePicker}
                                // onChange={setDatePicker}
                                size="large"
                                disabledDate={(current) => {
                                    if (!current) return false;

                                    // ❌ ไม่ใช่เดือนปัจจุบัน -> disable
                                    if (
                                        current.month() !== currentMonth ||
                                        current.year() !== currentYear
                                    ) {
                                        return true;
                                    }

                                    // ❌ ไม่ใช่วันที่ 12 และ 26 -> disable
                                    return current.date() !== 12 && current.date() !== 26;
                                }}
                            />
                            <Button
                                type="primary"
                                icon={<SearchOutlined />}
                                size="large"
                                style={{
                                    borderRadius: "8px",
                                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                    fontWeight: "bold",
                                    background: "linear-gradient(135deg, #667eea, blue)",
                                    border: "none",
                                }}
                                onClick={handleLoad}
                                disabled={loading}
                            >
                                ค้นหา
                            </Button>
                        </Space>
                    </Col>
                    <Col span={12} style={{ textAlign: "end" }}>
                        <Search
                            placeholder="ค้นหาสัญญา"
                            enterButton
                            onSearch={onSearch}
                            style={{
                                width: "auto",
                                borderRadius: "8px",
                            }}
                            size="large"
                        />
                    </Col>
                    <Col span={12} style={{ textAlign: "start", marginTop: "5px" }}>
                        <Space>
                            <Tooltip placement="bottom" title={arrData.length > 0 ? null : "โปรดเลือกประเภทข้อมูลก่อน !"} disabled={true}>
                                <Button
                                    type="primary"
                                    icon={<SaveOutlined />}
                                    onClick={insertData}
                                    disabled={arrData.length === 0 || loading}
                                >
                                    บันทึก
                                </Button>
                            </Tooltip>
                        </Space>
                    </Col>
                    <Col span={12} style={{ textAlign: "end", marginTop: "5px" }}>
                        <Button
                            type="primary"
                            danger
                            icon={<BarcodeOutlined />}
                            onClick={handleAddBarcode}
                            disabled={loading}
                            loading={loading}
                        >
                            นำเข้าเลขไปรษณีย์4
                        </Button>
                    </Col>
                </Row >
            </Card >
            <Card>
                <Spin spinning={loading} size="large" tip=" Loading... ">
                    <Row>
                        <Col span={"24"}>
                            <Table
                                style={{ marginTop: "10px" }}
                                size="small"
                                columns={columns}
                                dataSource={arrayTable}
                                scroll={{ x: 850 }}
                                footer={() => (
                                    <p>จำนวนสัญญาที่ค้นหาทั้งหมด {arrayTable?.length} </p>
                                )}
                            />
                        </Col>
                    </Row>
                    {isModalPickData ?
                        <PickData
                            open={isModalPickData}
                            close={setIsModalPickData}
                            date={datePicker}
                            contractSchema={selectedContract}
                        />
                        : null}
                    {isModalSearch ?
                        <CheckCONTNO
                            open={isModalSearch}
                            close={setIsModalSearch}
                            data={dataSearch}
                        />
                        : null}
                </Spin>
            </Card>
        </>
    )
}

const CreateCancelContract = MotionHoc(Main);
export default CreateCancelContract;